'use client'

import { addToWishlist, createWishList } from '@/app/actions/collections/wishlists'
import { Heart } from 'lucide-react'
import { useState } from 'react'
import { useModal } from '@/ui/context/ModalContext'
import LoginModal from '@/ui/context/modals/Login'

type WishButtonProps = {
	isWished: boolean
	productId: string
	absolute?: boolean
}

export default function WishButton({ isWished, productId, absolute = true }: WishButtonProps) {

	const [enabled, setEnabled] = useState(isWished)
	const { openModal, closeModal } = useModal()

	const handleWishlist = async (id: string) => {
		try {
			await addToWishlist(id)
			setEnabled(!enabled)
		} catch (error) {
			console.error(error)
			openModal(<LoginModal closeAction={closeModal} />)
		}
	}

	return (
		<>
			<button
				onClick={(e) => {
					e.preventDefault()
					e.stopPropagation()
					handleWishlist(productId)
				}}
				className={`h-10 w-10 ${absolute ? 'absolute top-5 right-5' : ''} ${enabled ? 'bg-primary' : 'bg-gray-400'
					} rounded-full z-10 flex items-center justify-center cursor-pointer hover:bg-primary-800 transition-all`}
			>
				<Heart className='size-5 text-white' />
			</button>
		</>
	)
}
